module.exports = __webpack_public_path__ + "static/media/css3-seeklogo.com.073b69c5.svg";